"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLayer = exports.updateLayer = exports.addLayer = exports.fetchLayersIfNeeded = exports.DELETE_LAYER = exports.UPDATE_LAYER = exports.ADD_LAYER = exports.FETCH_LAYERS = void 0;
var utils_1 = require("../../utils");
exports.FETCH_LAYERS = (0, utils_1.networkActionTypes)("FETCH_LAYERS");
exports.ADD_LAYER = (0, utils_1.networkActionTypes)("ADD_LAYER");
exports.UPDATE_LAYER = (0, utils_1.networkActionTypes)("UPDATE_LAYER");
exports.DELETE_LAYER = (0, utils_1.networkActionTypes)("DELETE_LAYER");
var fetchLayers = (0, utils_1.networkAction)(exports.FETCH_LAYERS, "/layers");
exports.fetchLayersIfNeeded = (0, utils_1.makeIfNeededAction)(fetchLayers, "layers");
var _addLayer = (0, utils_1.networkAction)(exports.ADD_LAYER, "/layers", "POST");
var addLayer = function (body, accessToken) { return function (dispatch, getState) {
    var state = getState();
    if (state.layers.isFetching || state.layers.isAdding || state.layers.isUpdating || state.layers.isDeleting)
        return;
    return dispatch(_addLayer(body, {}, accessToken));
}; };
exports.addLayer = addLayer;
var updateLayer = function (layerID, layerData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.layers.isFetching || state.layers.isAdding || state.layers.isUpdating || state.layers.isDeleting)
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_LAYER, "/layers/".concat(layerID), "PUT")(layerData, {}, accessToken));
    };
};
exports.updateLayer = updateLayer;
var deleteLayer = function (layerID, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.layers.isFetching || state.layers.isAdding || state.layers.isUpdating || state.layers.isDeleting)
            return;
        return dispatch((0, utils_1.networkAction)(exports.DELETE_LAYER, "/layers/".concat(layerID), "DELETE")({}, { id: layerID }, accessToken));
    };
};
exports.deleteLayer = deleteLayer;
